import { testimonials } from '@/mocks/site';
import SectionHeading from '@/components/feature/SectionHeading';
import Reveal from '@/components/feature/Reveal';

export default function TestimonialsSection() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-100 border-y border-background-200">
      <SectionHeading
        eyebrow="用户口碑"
        tone="accent"
        title="他们是这样把福利领到手的"
        desc="真实的使用感受往往比规则条文更有参考价值，以下内容来自参与者的反馈整理。"
      />

      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
        {testimonials.map((item, index) => (
          <Reveal key={item.name} delay={index * 80}>
            <figure className="h-full bg-background-50 border border-background-200 rounded-2xl p-5 md:p-6 flex flex-col">
              <span className="text-accent-500 text-lg">
                <i className="ri-double-quotes-l"></i>
              </span>
              <blockquote className="mt-3 text-sm text-foreground-700 leading-relaxed flex-1">
                {item.text}
              </blockquote>
              <figcaption className="mt-5 pt-5 border-t border-background-200 flex items-center gap-3">
                <span className="w-11 h-11 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={`${item.name} 的头像`}
                    title={`${item.name} - 爆瓜福利用户反馈`}
                    className="w-full h-full object-cover object-top"
                  />
                </span>
                <span className="min-w-0">
                  <span className="block text-sm font-medium text-foreground-950">{item.name}</span>
                  <span className="block text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}